var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useAnalyticsContext } from 'src/common/metrics';
import { useDefaultApiParams } from './useDefaultApiParams';
/**
 * Custom hook to fetch top-highlights product compliance data based on a single ASIN.
 */
export const useProductComplianceTopHighlights = ({ asin, enabled = true }) => {
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    const rumClient = useAnalyticsContext();
    return useQuery({
        queryKey: ['getProductComplianceTopHighlights', asin],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const start = Date.now();
            try {
                const result = yield HandshakePainterServiceApiV1.getProductComplianceTopHighlights({
                    asin: asin,
                    xUserLinked: defaultApiParams.xUserLinked,
                    xJoinId: defaultApiParams.xJoinId,
                    marketplaceId: defaultApiParams.marketplaceId,
                });
                rumClient.recordEvent('COMPLIANCE_TOP_HIGHLIGHTS_API_LATENCY', {
                    asin,
                    durationMs: Date.now() - start,
                    status: 'success',
                });
                return result;
            }
            catch (e) {
                rumClient.recordEvent('COMPLIANCE_TOP_HIGHLIGHTS_API_LATENCY', {
                    asin,
                    durationMs: Date.now() - start,
                    status: 'error',
                });
                const error = e;
                rumClient.recordEvent('COMPLIANCE_TOP_HIGHLIGHTS_API_ERROR', {
                    asin,
                    errorTitle: error === null || error === void 0 ? void 0 : error.title,
                    errorDetails: (_a = error === null || error === void 0 ? void 0 : error.detail) !== null && _a !== void 0 ? _a : String(error),
                });
                throw e;
            }
        }),
        enabled: enabled && !!asin,
    });
};
